import { useState, useEffect } from "react";
import {
  Box,
  Heading,
  List,
  Link,
  Text,
  Spinner,
  Flex,
} from "@chakra-ui/react";
import type { EpisodeListItem } from "../interfaces";
import { getAllEpisodes } from "../api-client";

export function EpisodesPage() {
  const [episodes, setEpisodes] = useState<EpisodeListItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchEpisodes = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await getAllEpisodes() as EpisodeListItem[];
        setEpisodes(data);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchEpisodes();
  }, []);

  if (loading) {
    return (
      <Flex justify="center" align="center" h="400px">
        <Spinner size="xl" />
      </Flex>
    );
  }

  if (error) {
    return (
      <Box textAlign="center" py={10}>
        <Heading size="lg" color="red.500">
          Error
        </Heading>
        <Text mt={4}>{error}</Text>
      </Box>
    );
  }

  return (
    <Box w="full">
      <Heading as="h1" size="2xl" mb={6}>
        All Episodes
      </Heading>
      <List.Root variant="plain" colorPalette="teal">
        {episodes.map((episode) => (
          <List.Item
            key={episode.episode_number}
            p={4}
            borderWidth="1px"
            borderRadius="md"
            _hover={{ bg: "blackAlpha.50" }}
          >
            <Link
              href={`/episode/${episode.episode_number}`}
              _hover={{ textDecoration: "none" }}
            >
              <Heading as="h3" size="md" mb={1}>
                Episode {episode.episode_number}: {episode.title}
              </Heading>
              <Text fontSize="sm" color="gray.500">
                {new Date(episode.published_at).toLocaleDateString()}
              </Text>
            </Link>
          </List.Item>
        ))}
      </List.Root>
    </Box>
  );
}
